// Section 4 phase 7 (Society), Sections 11 and 16: compulsory schooling pulls children from work,
// the school teaches, apprentices and workers learn and unused skills decay, the festival is held
// in its season, the society trust rows are applied (promised builds, harsh-justice norm), a
// refusal may occur below trust 25, and uncovered small children are warned about. Norm counters
// and the Charismatic trust spread run at the end of the season (lifecycle phase), after the
// crime phase has written this season's justice entries.
import { uncoveredUnderSix } from '../../core/queries';
import type { Phase } from '../../core/types';
import { holdFestival } from './festival';
import { pullFromWork, runSchool } from './school';
import { learnAndForget } from './skills';
import { maybeRefuse, reportTrust, seasonalTrust, type TrustTally } from './trust';

export const societyPhase: Phase = {
  id: 'society',
  reads: ['people', 'households', 'policies', 'buildings', 'currentReport', 'counters', 'norms'],
  writes: ['people', 'currentReport', 'stocks', 'festival', 'counters'],
  projection: 'run',
  run(ctx) {
    pullFromWork(ctx);
    runSchool(ctx);
    learnAndForget(ctx);
    const tally: TrustTally = new Map();
    holdFestival(ctx, tally);
    seasonalTrust(ctx, tally);
    reportTrust(ctx, tally);
    maybeRefuse(ctx);
    const uncovered = uncoveredUnderSix(ctx.cfg, ctx.state).length;
    if (uncovered > 0)
      ctx.report.add({ kind: 'warning', code: 'children-uncovered', amount: uncovered });
    return 'done';
  },
};
